export const SELECT_TYPES = {
  DEFAULT_NEXT: 'default-next',
  SECONDARY_NEXT: 'secondary-next',
  MODERN: 'modern',
  MODERN_LARGE_LIGHT_NEXT: 'modern-large-light-next'
}
